import { dev } from '@seech-sub/core-ng';
import { Environment } from '../app/models';

export const environment: Environment = {
  ...dev,
  BASE_API_URL: 'https://dev-api-operations.seech.com',
  CDN_BASE_URL: 'https://dev-cdn.seech.com/operations',
  CLIENT_ID: 'C8B8A6D4-5B86-42FA-98A5-6C9A4F4E8B2B',
  GOOGLE_ANALYTICS_ID: '',
};
